export const getTodayWithResetHours = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today;
};

export const getToday = () => new Date();
